let host = 'https://candle-royale.herokuapp.com/'
module.exports = host